import * as Sentry from '@sentry/nextjs';

import Button from '@components/Button';
import { Container } from '@shared';

import { ButtonGroups, Wrapper } from './styled';

interface InternalServerErrorProps {
  eventId?: string;
}

const InternalServerError = ({ eventId }: InternalServerErrorProps) => {
  return (
    <Container maxWidth='lg'>
      <Wrapper>
        <img
          src='/static/images/internal_server_error.webp'
          alt='Çalışmalar devam ediyor'
        />
        <h1>500</h1>
        <p>Internal Server Error</p>

        <ButtonGroups>
          <Button onClick={() => (window.location.href = '/')}>
            Anasayfaya Dön
          </Button>

          {eventId && (
            <Button
              type='secondary'
              onClick={() =>
                Sentry.showReportDialog({
                  eventId: eventId as string,
                  successMessage: 'Geri bildiriminiz için teşekkürler!',
                  title: 'Geri bildiriminizi paylaşın',
                  labelName: 'İsminiz',
                  labelEmail: 'E-posta adresiniz',
                  labelComments: 'Geri bildiriminiz',
                })
              }
            >
              Geri Bildiriminizi Paylaşın
            </Button>
          )}
        </ButtonGroups>
      </Wrapper>
    </Container>
  );
};

export default InternalServerError;
